import { useState } from 'react';
import { players, positionGroups, PositionGroupFilter } from '@/mocks/roster';
import PlayerCard from './PlayerCard';

export default function RosterSection() {
  const [activeFilter, setActiveFilter] = useState<PositionGroupFilter>('All');
  const [searchQuery, setSearchQuery] = useState('');

  const filtered = players.filter((p) => {
    const matchesGroup = activeFilter === 'All' || p.positionGroup === activeFilter;
    const matchesSearch =
      p.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      p.position.toLowerCase().includes(searchQuery.toLowerCase()) ||
      p.college.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesGroup && matchesSearch;
  });

  return (
    <section className="w-full py-16 md:py-20 px-6 md:px-12 bg-[#f8f6fb]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <p className="text-[#4a1a6b] text-xs font-bold tracking-widest uppercase mb-2" style={{ fontFamily: "'Oswald', sans-serif" }}>
              2025–26 Season
            </p>
            <h2 className="text-3xl md:text-4xl font-black text-[#2a0a3d] uppercase" style={{ fontFamily: "'Oswald', sans-serif" }}>
              Player Roster
            </h2>
            <p className="text-gray-500 text-sm mt-2">Click any card to flip and see player details</p>
          </div>

          {/* Search */}
          <div className="relative w-full md:w-64">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></i>
            <input
              type="text"
              placeholder="Search players..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-9 pr-4 py-2.5 rounded-full border border-gray-200 bg-white text-sm text-gray-700 focus:outline-none focus:border-[#4a1a6b] transition-colors"
              style={{ fontFamily: "'Oswald', sans-serif" }}
            />
          </div>
        </div>

        {/* Filter Tabs */}
        <div className="flex items-center gap-2 flex-wrap mb-8">
          {positionGroups.map((group) => (
            <button
              key={group}
              onClick={() => setActiveFilter(group)}
              className={`whitespace-nowrap px-5 py-2 rounded-full text-xs font-bold tracking-widest uppercase cursor-pointer transition-all duration-300 ${
                activeFilter === group
                  ? 'bg-[#4a1a6b] text-white'
                  : 'bg-white text-gray-600 border border-gray-200 hover:border-[#4a1a6b] hover:text-[#4a1a6b]'
              }`}
              style={{ fontFamily: "'Oswald', sans-serif" }}
            >
              {group}
            </button>
          ))}
          <span className="ml-auto text-xs text-gray-400" style={{ fontFamily: "'Oswald', sans-serif" }}>
            {filtered.length} player{filtered.length !== 1 ? 's' : ''}
          </span>
        </div>

        {/* Grid */}
        {filtered.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {filtered.map((player) => (
              <PlayerCard key={player.id} player={player} />
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-[#4a1a6b]/10">
              <i className="ri-user-search-line text-2xl text-[#4a1a6b]"></i>
            </div>
            <p className="text-gray-500 text-sm" style={{ fontFamily: "'Oswald', sans-serif" }}>No players found matching your search.</p>
          </div>
        )}
      </div>
    </section>
  );
}
